import cx from 'classnames';
import styles from '../../styles/rent.scss';
import { Link } from '../../configs/routes';
import {
  calcDateRange,
  calcRemainingDays,
  calcRentPerMonth,
  calcRemainingRent,
  getDateRepr,
} from '../../utils/rentUtils';

import { RentReceipts } from './RentReceipts';

export const SaveTaxesCard = () => (
  <div className={cx(styles['card-panel'], styles['indigo-text'], 'mb20')}>
    <div className={cx(styles['header-cta'], 'text-left')}>
      <div className={cx(styles['title'])}>Save upto ₹46,800 in taxes now</div>
      <div className={cx(styles['subtitle_caption'])}>
        <img
          src="https://assets1.cleartax-cdn.com/cleartax/images/1610368674_iconcheckbulletpoint1.png"
          className={cx(styles['tick'])}
        />
        <div> Invest in expert curated ELSS plans </div>
      </div>
      <div className={cx(styles['subtitle_caption'])}>
        <img
          src="https://assets1.cleartax-cdn.com/cleartax/images/1610368674_iconcheckbulletpoint1.png"
          className={cx(styles['tick'])}
        />
        <div> Get Instant proof on investments </div>
      </div>
      <div className={cx(styles['btn_container'])}>
        <Link route={'/save/plan/19?ref=RentReceiptsGenerator'}>
          <a className={cx('btn', styles['indigo'], styles['darken-2'])}>
            Save taxes now
          </a>
        </Link>
      </div>
    </div>
  </div>
);

export const RentReceiptInfo = () => (
  <div className={cx(styles['rentreceipt-content'], 'text-center')}>
    <h1 className={cx(styles['title'])}>Generate FREE Rent Receipts</h1>
    <ul className={cx(styles['list'], 'mb40')}>
      <li>Avoid last minute hassle of arranging rent receipts</li>
      <li>Fill the required details</li>
      <li>Print the receipt in PDF Format</li>
      <li>Get the receipt signed from your landlord</li>
      <li>Submit it to your company's HR department</li>
    </ul>
  </div>
);

export const TreeBackground = () => (
  <div className={cx(styles['back-ground'], styles['show-in-web'])}>
    <div className={cx(styles['indi'])} />
    <div className={cx(styles['indi'])} />
  </div>
);

export const RentReceipt = (props: any) => {
  const { rent, address, name, pan, datefrom, dateto } = props.data;
  let { owner } = props.data;
  owner = owner.charAt(0).toUpperCase() + owner.slice(1);

  const rentPerMonth = calcRentPerMonth(
    datefrom,
    dateto,
    '-',
    rent,
    calcDateRange,
    calcRemainingRent,
    calcRemainingDays
  );

  return (
    <div className={cx('row', styles['main-receipt'])}>
      <div className={cx('col small-12', styles['head'])}>
        <h4 className="text-center">
          <p>Here are your rent receipts</p>
          <p>
            <small>(We have also emailed them to you)</small>
          </p>
        </h4>
      </div>
      <div className="col small-12  text-center">
        <a
          href="#results"
          onClick={() => window.print()}
          className={cx('btn', styles['orange-btn'])}
        >
          {'Print Receipts'.toUpperCase()}
        </a>
      </div>
      <div
        className={cx(
          'col small-12',
          styles['print-receipts'],
          styles['print-section']
        )}
      >
        <RentReceipts
          rentPerMonth={rentPerMonth}
          address={address}
          name={name}
          owner={owner}
          pan={pan}
          getDateRepr={getDateRepr}
        />
      </div>
      <div className={cx('col small-12', styles['re-receipt'])}>
        <div className="row ml0 mr0">
          <div className="tips col small-12 text-center">
            <div className="row ml0 mr0">
              <div className="col small-12">
                <p className={cx(styles['pad8'])}>
                  <strong className="tip-text">
                    Tip: Invest in 80C before March 2022 and pay less tax for FY
                    2021-22.
                  </strong>
                </p>
                <p className={cx(styles['pad8'])}>
                  Finish your 80C investment with ClearTax and generate
                  investment proofs.
                </p>
                <p style={{ padding: '15px 8px 15px 8px' }}>
                  <Link route={'/save?ref=RentReceiptsGenerator'}>
                    <a
                      className={cx('btn', styles['rent-btn'], styles['green'])}
                    >
                      {'Invest in 80C'.toUpperCase()}
                    </a>
                  </Link>
                </p>

                <div className={cx(styles['pad8'])}>
                  <ul
                    className={cx(styles['checked-list'], styles['left-align'])}
                  >
                    <li>Quick &amp; paperless process</li>
                    <li>Higher interest rates</li>
                    <li>Shortest lock-in period</li>
                  </ul>
                </div>

                <p className={cx(styles['pad8'], styles['small'])}>
                  For any questions on tax filing, write to us on{' '}
                  <a href="mailto:support@cleartax.in">support@cleartax.in</a>{' '}
                  and we will help.
                </p>
              </div>
            </div>
          </div>

          <div className="col small-12 text-center">
            <div className="row">
              <div className="col small-12">
                <h5>Tell your friends </h5>
                <p className={cx(styles['pad8'])}>
                  Tell your friends to create their rent receipts on ClearTax.
                </p>
                <p className={cx(styles['pad8'])}>
                  <small>
                    {' '}
                    <strong>
                      {' '}
                      (Don't worry, your rent receipts won't be shared :P)
                    </strong>
                  </small>
                </p>
              </div>
              <div
                className={cx(
                  styles['box-flex'],
                  styles['pad8'],
                  styles['margin2']
                )}
              >
                <div className="col small-12 medium-6">
                  <a
                    href="https://www.facebook.com/sharer/sharer.php?u=https://cleartax.in/s/elss"
                    target="_blank"
                    className={cx(
                      'btn z-depth-0',
                      styles['rent-btn'],
                      styles['fb-blue']
                    )}
                  >
                    {'Facebook'.toUpperCase()}
                  </a>
                </div>
                <div className="col small-12 medium-6">
                  <a
                    href="https://twitter.com/home?status=https://cleartax.in/s/elss https://cleartax.in/s/elss"
                    target="_blank"
                    className={cx(
                      'btn z-depth-0',
                      styles['rent-btn'],
                      styles['tw-blue']
                    )}
                  >
                    {'Twitter'.toUpperCase()}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/rent/staticComponents.tsx